import React from 'react';
import { motion } from 'framer-motion';
import { Accordion } from './Accordion';
const bonosData = [{
  id: 'bono-1',
  title: 'Mapa de Conceptos Clave por Materia',
  icon: '🗺️',
  description: 'Los conceptos más importantes de cada área, organizados en un solo lugar.',
  purpose: 'Para que antes del parcial sepas exactamente qué repasar. Un mapa visual por área que te dice por dónde empezar cuando el tiempo aprieta.'
}, {
  id: 'bono-2',
  title: 'Rutina de Estudio Semanal de 20 Minutos',
  icon: '✅',
  description: 'La rutina que convierte el estudio disperso en un hábito real.',
  purpose: 'Para que no dependas de la motivación ni de los días de inspiración. Son 20 minutos diarios con una estructura clara que hace que avances aunque estés cansado.'
}, {
  id: 'bono-3',
  title: 'Glosario de Términos Psicológicos Esenciales',
  icon: '💬',
  description: 'Los 150 términos que más aparecen en parciales y prácticas, definidos con claridad.',
  purpose: 'Para que nunca te quedes en blanco cuando el docente pregunta. Cubre psicoanálisis, TCC, psicopatología y clínica — los cuatro pilares de la carrera.'
}, {
  id: 'bono-4',
  title: 'Tracker de Avance Semestral',
  icon: '📊',
  description: 'El sistema visual que hace visible tu progreso semana a semana.',
  purpose: 'Para que nunca dudes de que avanzás. Cada semana que completás queda registrada y podés ver tu transformación de materia en materia.'
}];
export function Bonos() {
  const accordionItems = bonosData.map((bono, index) => ({
    id: bono.id,
    title: <div className="flex flex-col gap-1" data-id="element-25">
        <div className="flex items-center gap-2 text-white font-bold" data-id="element-26">
          <span className="text-brand-lilac" data-id="element-27">
            BONO 0{index + 1} — {bono.icon}
          </span>
          <span className="flex-1" data-id="element-28">{bono.title}</span>
        </div>
        <div className="flex items-center gap-2 text-sm" data-id="element-29">
          <span className="line-through text-gray-500" data-id="element-30">$8.000</span>
          <span className="bg-brand-gold text-brand-dark text-xs font-bold px-2 py-0.5 rounded" data-id="element-31">
            GRATIS
          </span>
        </div>
      </div>,
    content: <div className="pt-2 text-gray-200" data-id="element-32">
        <p className="font-medium mb-3" data-id="element-33">{bono.description}</p>
        <div className="bg-brand-violet/15 border border-brand-violet/20 p-3 rounded-lg text-sm" data-id="element-34">
          <span className="font-bold text-brand-lilac" data-id="element-35">Para qué sirve:</span>{' '}
          {bono.purpose}
        </div>
      </div>
  }));
  return <section className="bg-brand-darker py-16 px-4 sm:px-6 lg:px-8" data-id="element-36">
      <div className="max-w-2xl mx-auto" data-id="element-37">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-10" data-id="element-38">
          <span className="inline-flex items-center gap-1.5 bg-brand-gold/15 text-brand-gold border border-brand-gold/30 text-xs font-bold px-3 py-1 rounded-full mb-4" data-id="element-39">
            🎁 4 BONOS GRATIS
          </span>
          <h2 className="text-2xl sm:text-3xl font-bold text-white mb-3" data-id="element-40">
            4 bonos incluidos. Gratis. Siempre.
          </h2>
          <p className="text-gray-300 font-medium text-lg" data-id="element-41">
            Valor total:{' '}
            <span className="line-through text-gray-500" data-id="element-42">$32.000 ARS</span>{' '}
            <span className="text-brand-gold font-bold" data-id="element-43">→ $0</span> con tu
            sistema.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} data-id="element-44">
          <Accordion items={accordionItems} className="mb-8" itemClassName="bg-white/5 border-brand-gold/20" headerClassName="hover:bg-white/5" contentClassName="border-white/10" data-id="element-45" />
        </motion.div>
      </div>
    </section>;
}